import axios from 'axios';

const axiosClient = axios.create();

// Set token from localStorage on creation
const token = localStorage.getItem('TOKEN');
if (token) {
    axiosClient.defaults.headers.common['Authorization'] = `Token ${token}`;
}

// Response interceptor: handle 401 (expired/invalid token)
axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Don't redirect if this is the sign-in request itself
            const isAuthRequest = error.config?.url?.includes('/rest-auth/login');
            if (!isAuthRequest) {
                localStorage.clear();
                localStorage.setItem('IS_AUTHENTICATED', 'false');
                window.location.href = '/accounts/signin';
                return new Promise(() => {}); // prevent further .catch handling
            }
        }
        return Promise.reject(error);
    }
);

export default axiosClient;
